import type { FilterPreference } from '@/funding-sdk';
import { ResponseError } from '@/lib/exceptions';
import BaseService from './BaseService';

class PreferenceService extends BaseService {
  getFilterPreference = async (screenKey: string): Promise<Record<string, unknown> | null> => {
    try {
      const preference = await this.get<FilterPreference | Response>({
        path: `preferences/filters/${screenKey}`,
      });
      // Funding-service returns 204 when nothing is saved (#24263); BaseService yields the raw Response.
      if (preference instanceof Response && preference.status === 204) {
        return null;
      }
      return (preference as FilterPreference).filterModel ?? null;
    } catch (e) {
      // Legacy 404 before #24263.
      if (e instanceof ResponseError && e.statusCode === 404) {
        return null;
      }
      throw e;
    }
  };

  saveFilterPreference = (screenKey: string, filterModel: Record<string, unknown> | null) =>
    this.put<{ filterModel: Record<string, unknown> | null }, FilterPreference>({
      path: `preferences/filters/${screenKey}`,
      body: { filterModel },
    });

  deleteFilterPreference = (screenKey: string) => this.delete<void>({ path: `preferences/filters/${screenKey}` });
}

export default PreferenceService;
